import React, { ReactNode } from 'react'

export interface CommonWebsiteFooterProps {
  htmlAttrId: string
  children: ReactNode
}

export const CommonWebsiteFooter = ({
  htmlAttrId,
  children,
}: CommonWebsiteFooterProps) => <footer id={htmlAttrId}>{children}</footer>
